import type { MemoizedFn } from 'memoize-one';
import memoize from 'memoize-one';

import { GlobalTransitionPreloader } from './GlobalTransitionPreloader.ts';

export const getGlobalTransitionPreloader: MemoizedFn<() => GlobalTransitionPreloader> = memoize(
	(): GlobalTransitionPreloader => {
		return new GlobalTransitionPreloader();
	},
);
